// extracted by mini-css-extract-plugin
export default {"desktopGrid":"styles_desktopGrid__01XU7"};